module.exports = __webpack_public_path__ + "static/media/banner-desktop.cb064b75.jpg";